import { z } from 'zod'
import { Pagination } from '../helper'

export const reportGenerationStatusEnum = z.enum([
  'Pending',
  'Generating',
  'Success',
  'Failed',
  'Retrying',
])

export const reportGenerationLogSchema = z.object({
  id: z.string(),
  reportId: z.string(),
  status: z.string().nullable(),
  startedAt: z.string(),
  completedAt: z.string().nullable(),
  attachCsv: z.boolean(),
  attachPdf: z.boolean(),
  periodFrom: z.string(),
  periodTo: z.string(),
  totalDevices: z.number(),
  totalRows: z.number(),
  errorMessage: z.string().nullable(),
  triggeredBy: z.string().nullable(),
  triggeredByUserId: z.string().nullable(),
})

export type TReportGenerationStatus = z.infer<typeof reportGenerationStatusEnum>
export type TReportGenerationLog = z.infer<typeof reportGenerationLogSchema>
export type TReportGenerationLogList = Pagination<TReportGenerationLog>
